import React from "react";
import PropTypes from "prop-types";

import UIEmptyState from "../ui/UIEmptyState";
import { fromLegacyEmptyStateProps } from "../ui/UIEmptyState/fromLegacyEmptyStateProps";

const EmptyState = (props) => (
  <UIEmptyState {...fromLegacyEmptyStateProps(props)} />
);

export default EmptyState;

EmptyState.propTypes = {
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  description: PropTypes.string,
  buttonLabel: PropTypes.string,
  handleCreate: PropTypes.func,
  showActionButton: PropTypes.bool,
  actionBtnDisabled: PropTypes.bool,
  imgSrc: PropTypes.string,
  containerClasses: PropTypes.string,
  imgClass: PropTypes.string,
};

EmptyState.defaultProps = {
  showActionButton: true,
};
